/* @flow */
import Button from 'components/Button.jsx';
import GroupMessageBase from 'groups/components/GroupMessageBase.jsx';
// GroupMessageHeader has to precede GroupMessageContent
// https://remind.slack.com/archives/frontend/p1461709761000230
import GroupMessageHeader from 'groups/components/GroupMessageHeader.jsx';
import GroupMessageContent from 'groups/components/GroupMessageContent.jsx';
import GroupMessageInformation from 'groups/components/GroupMessageInformation.jsx';
import Link from 'components/Link.jsx';
import Message from 'entities/Message';
import React from 'react';

import './styles/MessageView.scss';

type Props = {
  message: Message,
};

const DownloadLink = ({ file }: {file: Object}) => (
  <Link
    className="MessageView-downloadLink"
    href={file.getUrls().cdn}
    download
    eventElementName="MessageView-downloadLink">
    <Button
      type="submit"
      level="primary"
      full>
      Download
    </Button>
  </Link>
);

export class MessageView extends React.Component {
  props: Props;

  render() {
    const { message } = this.props;
    const file = message.getFile();
    const sender = message.getSender();

    return (
      <GroupMessageBase message={message}>
        <GroupMessageHeader
          author={sender.getName()}
          initials={sender.getInitials()}
          color={sender.getColor()}
          senderId={sender.id}
        />
        <GroupMessageContent />
        <GroupMessageInformation />
        {file && <DownloadLink file={file} /> }
      </GroupMessageBase>
    );
  }
}

export default MessageView;



// WEBPACK FOOTER //
// ./src/messages/components/MessageView.jsx